(function () {
  function initGradientBannerHeader(sectionEl) {
    if (!sectionEl || !sectionEl.classList.contains('gradient-banner--transparent-header')) return;

    const root = document.documentElement;
    root.classList.add('gb-transparent-header');

    const textColor = sectionEl.dataset.headerTextColor;
    if (textColor) {
      root.style.setProperty('--gb-transparent-header-text', textColor);
    }

    const updateSolidState = () => {
      const rect = sectionEl.getBoundingClientRect();
      const headerHeight = parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 80;
      if (rect.bottom <= headerHeight + 8) {
        root.classList.add('gb-transparent-header--solid');
      } else {
        root.classList.remove('gb-transparent-header--solid');
      }
    };

    updateSolidState();
    window.addEventListener('scroll', updateSolidState, { passive: true });
    window.addEventListener('resize', updateSolidState);

    sectionEl._gbHeaderCleanup = () => {
      window.removeEventListener('scroll', updateSolidState);
      window.removeEventListener('resize', updateSolidState);
      root.classList.remove('gb-transparent-header', 'gb-transparent-header--solid');
      root.style.removeProperty('--gb-transparent-header-text');
    };
  }

  function cleanupGradientBannerHeader(sectionRoot) {
    const banner = sectionRoot && sectionRoot.querySelector
      ? sectionRoot.querySelector('.gradient-banner--transparent-header')
      : null;
    if (banner && typeof banner._gbHeaderCleanup === 'function') {
      banner._gbHeaderCleanup();
    } else {
      document.documentElement.classList.remove('gb-transparent-header', 'gb-transparent-header--solid');
      document.documentElement.style.removeProperty('--gb-transparent-header-text');
    }
  }

  function boot() {
    document.querySelectorAll('.gradient-banner--transparent-header').forEach(initGradientBannerHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const banner = event.target.querySelector('.gradient-banner--transparent-header');
    if (banner) initGradientBannerHeader(banner);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupGradientBannerHeader(event.target);
  });
})();
